import React, { useState } from 'react';
import AlbumBook from '../components/AlbumBook';

const initialAlbums = [
  { id: '1', name: 'Tantie et Tonton', cover_color: 'noir', photo_count: 3 },
  { id: '2', name: 'Mes Filles', cover_color: 'ivoire', photo_count: 12 },
  { id: '3', name: 'Famille', cover_color: 'vert', photo_count: 7 },
  { id: '4', name: 'Ete 2024', cover_color: 'bleu', photo_count: 24 },
  { id: '5', name: 'Mes filles', cover_color: 'or_vegetal', photo_count: 5 },
  { id: '6', name: 'Fleurs de Nuit', cover_color: 'fleurs_nuit', photo_count: 8 },
  { id: '7', name: 'Souvenirs', cover_color: 'marron', photo_count: 15 },
  { id: '8', name: 'Mariage', cover_color: 'or', photo_count: 42 },
  { id: '9', name: 'Bapteme', cover_color: 'ivoire', photo_count: 9 },
];

export default function CoffretTemoin() {
  const [albums, setAlbums] = useState(initialAlbums);

  const handleColorChange = (albumId, newColor) => {
    setAlbums(prev => prev.map(a => a.id === albumId ? { ...a, cover_color: newColor } : a));
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0A0A0A',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 40,
    }}>
      <h2 style={{
        fontFamily: "'Georgia', serif",
        color: '#D4AF37',
        fontSize: 22,
        marginBottom: 40,
        letterSpacing: 1,
      }}>
        Coffret Temoin — Design Heritage
      </h2>
      <div style={{
        display: 'flex',
        gap: 32,
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}>
        {albums.map(a => (
          <AlbumBook
            key={a.id}
            album={a}
            size="md"
            isActive={false}
            onClick={() => {}}
            onColorChange={(color) => handleColorChange(a.id, color)}
            onRename={() => {}}
            onDelete={() => {}}
          />
        ))}
      </div>
    </div>
  );
}
